import React from 'react';
import PropTypes from 'prop-types';

function TextualToggle({ active = false, onClick, children, className = '' }) {
    const _onClick = event => {
        onClick(active, event);
    };

    let _classes = ['textual-toggle', ...className.split(' ')];

    if (active) {
        _classes.push('active');
    }

    return (
        <span className={_classes.join(' ')} onClick={_onClick}>
            {children}
        </span>
    );
}

TextualToggle.propTypes = {
    /**
     * active status managed from parent component
     */
    active: PropTypes.bool,
    /**
     * function executed on click
     */
    onClick: PropTypes.func,
    /**
     * label/text to display
     */
    children: PropTypes.any,
    /**
     * additional classes
     */
    className: PropTypes.string
};

export default TextualToggle;
